import { useState } from "react"
import { Link, NavLink, useLocation } from "react-router-dom"
import { Button, Container, Dropdown, Icon, Image, Menu, Sidebar } from "semantic-ui-react"
import AuthenticationService from "../main/AuthenticationService"

export default function MenuSistema({openModal,perfil,nome}) {

  const [isSideBarOpen, setIsSideBarOpen] = useState(false)
  const location = useLocation();
  const path = location.pathname;

  const abrirSideBar = ( () => {
    setIsSideBarOpen(!isSideBarOpen)
  })

  return(
    <>
      <Menu size="large" className="navbar__menu" fixed="top" color='blue' 
        style={{
          backgroundColor:'white', 
          boxShadow: "0px 1px 2px rgb(50 50 50 / 34%)",
          zIndex: openModal ? "901" : "1003"
        }}
      >
        <Container>
          <Menu.Item 
              icon='bars'
              className='navbar__item--mobile'
              as={Button} 
              onClick={abrirSideBar}
          />
      
          <Menu.Item className="no-hover">
            <img alt="logo kgm" src='/kgm-lan-logotipo.png' style={{ height: '35px', width: 'auto', imageRendering: 'crisp-edges', filter: 'drop-shadow(0px 2px 2px rgba(0,0,0,0.1))' }} />
          </Menu.Item>
          {(perfil === "Comercial" || perfil === "Financeiro" || perfil === "Admin") &&
            <Menu.Item 
              className='navbar__item--pc' 
              as={Link} 
              to='/gestao-comissoes'
              active={path === '/gestao-comissoes'}
              style={{ padding: '0 1.5rem', fontWeight: path === '/gestao-comissoes' ? 'bold' : '500' }}
            >
              Gestão de Comissões
            </Menu.Item>
          }
          <Menu.Item 
            className='navbar__item--pc' 
            as={Link} 
            to='/consulta-vendas-agenciadas'
            active={path === '/consulta-vendas-agenciadas'}
            style={{ padding: '0 1.5rem', fontWeight: path === '/consulta-vendas-agenciadas' ? 'bold' : '500' }}
          >
            Consulta de Vendas Agenciadas
          </Menu.Item>
          {perfil === "Admin" && 
            <Menu.Item 
              className='navbar__item--pc' 
              as={Link} 
              to='/administrar-usuarios'
              active={path === '/administrar-usuarios'}
              style={{ padding: '0 1.5rem', fontWeight: path === '/administrar-usuarios' ? 'bold' : '500' }}
            >
              Administrar Usuários
            </Menu.Item>
          }
          <Menu.Menu position="right" className="navbar__item--pc" >
            <Dropdown style={{height:'100%'}} item pointing text={nome}>
              <Dropdown.Menu>
                <Dropdown.Item
                  as={Link} 
                  to='/alterar-senha'
                >
                  <Icon name='key' className='blue-icon' />
                  Alterar Senha
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link} 
                  to='/'
                  onClick={ () => AuthenticationService.logout()}
                >
                  <Icon name='power off' className='blue-icon' />
                  Sair
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Menu>
          </Container>
      </Menu>
      
      <Sidebar
          as={Menu}
          animation='overlay'
          icon='labeled'
          onHide={() => setIsSideBarOpen(false)}
          vertical
          className='navbar__item--mobile navbar--mobile'
          visible={isSideBarOpen}
          width='thin'
      >
          <Menu.Item
              name='close'
              onClick={abrirSideBar}
              className='navbar__item--mobile--close'
          >
              <Icon 
                  fitted
                  name='close' 
                  size='tiny'
              />
          </Menu.Item>
          {(perfil === "Comercial" || perfil === "Financeiro" || perfil === "Admin") &&
            <Menu.Item
              content='Gestão de Comissões'
              className='navbar__item--mobile'
              as={NavLink} 
              style={{fontWeight: 'bold'}}
              to='/gestao-comissoes'
            />
          }
          <Menu.Item
            content='Consulta de Vendas Agenciadas'
            className='navbar__item--mobile'
            as={NavLink} 
            style={{fontWeight: 'bold'}}
            to='/consulta-vendas-agenciadas'
          />
          {perfil === "Admin" && 
            <Menu.Item
              content='Administrar Usuários'
              className='navbar__item--mobile'
              as={NavLink} 
              style={{fontWeight: 'bold'}}
              to='/administrar-usuarios'
            />
          }
          <Menu.Item>
              <Menu.Header>{nome}</Menu.Header>
              <Menu.Menu>
                <Menu.Item
                  className='navbar__item--mobile'
                  as={NavLink} 
                  style={{fontWeight: 'bold'}}
                  to='/alterar-senha'
                >
                  <Icon name='key' className='blue-icon' />
                  Alterar Senha
                </Menu.Item>
                <Menu.Item
                  className='navbar__item--mobile'
                  as={NavLink} 
                  style={{fontWeight: 'bold'}}
                  to='/'
                  onClick={ () => AuthenticationService.logout()}
                >
                  <Icon name='power off' className='blue-icon' />
                  Sair
                </Menu.Item>
              </Menu.Menu>
          </Menu.Item>
      </Sidebar>
      <div className={isSideBarOpen? 'dimmed-screen' : ''}></div>
    </>
  )
}